import { ReservationStatus } from './reservation-detail';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'reservationStatus'
})
export class ReservationStatusPipe implements PipeTransform {

  transform(value: ReservationStatus, args?: any): string {
    switch (value) {
      case ReservationStatus.Unknown:
        return 'Unknown';
      case ReservationStatus.Created:
        return 'Created';
      case ReservationStatus.Paid:
        return 'BOOKING CONFIRMED (PRE-PAID)';
      case ReservationStatus.Cancelled:
        return 'CANCELLED';
      default:
        return '';
    }
  }
}
